"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cutOffDecimalPlaces = exports.getOptionalProperty = exports.convertToBoolean = exports.cloneJSON = void 0;
/**
 * Deep clone json.
 * Circular properties not supported.
 * @param obj object to be cloned
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const cloneJSON = obj => {
    try {
        return JSON.parse(JSON.stringify(obj));
    }
    catch {
        return obj;
    }
};
exports.cloneJSON = cloneJSON;
const convertToBoolean = (value) => {
    return String(value).toLowerCase() === 'true';
};
exports.convertToBoolean = convertToBoolean;
/**
 * Extract out a property from an object, whether the object has a defined property or not
 *
 * @param obj the object to extract property from
 * @param prop the name of the property
 * @returns value of the property or undefined if it does not exist
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getOptionalProperty(obj, prop) {
    return prop in obj ? obj[prop] : undefined;
}
exports.getOptionalProperty = getOptionalProperty;
// Note: not to confuse this function with the above function (limitDecimalCount), since the 2 have different input and return types, and possible values
/**
 * Cut off a decimal string number to a specified number of decimal places.
 * Return `undefined` if input value is undefined
 *
 * @param value to be cut off
 * @param decimal number of decimal places, default to 2
 * @returns the cut off value, or undefined if input is falsy
 */
function cutOffDecimalPlaces(value, decimal = 2) {
    if (!value) {
        return undefined;
    }
    const float = parseFloat(value);
    return float.toFixed(decimal);
}
exports.cutOffDecimalPlaces = cutOffDecimalPlaces;
//# sourceMappingURL=basicUtility.js.map